import api from 'common/api';

export const getFilterCargoTraceInformationAPI = (params: any) => api.get('/cargo-information-export/search', params);

export const getCargoUserListAPI = (params: any) => api.get('/cargo-information-export/user-list', params);

export const DOWNLOAD_CARGO_FILE_API = '/cargo-information-export/download';

export const DOWNLOAD_CARGO_PDF_API = '/cargo-information-export/download-pdf';
